// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { OnlineCourseFeedbackData } from '../../types/OnlineCourseFeedback';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface InitState {
  onlineCourseFeedbackData: { [key: string]: OnlineCourseFeedbackData[] };
  canReview: boolean;
  loadingType: LoadingType;
  isLoading: boolean;
  hasMoreFeedback: boolean;
  error?: Error;
}

const { getOnlineCourseFeedbackActions } = actionCreatorsList;
export const initialState: InitState = {
  onlineCourseFeedbackData: {},
  canReview: false,
  isLoading: true,
  hasMoreFeedback: true,
  loadingType: LoadingType.NEW
};

export default function (state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(getOnlineCourseFeedbackActions.request): {
      const { loadingType } = action.payload;

      return {
        ...state,
        isLoading: true,
        loadingType,
        error: undefined
      };
    }
    case getType(getOnlineCourseFeedbackActions.success): {
      const { id, onlineCourseFeedbackData, loadingType, canReview } = action.payload;
      const newData =
        loadingType === LoadingType.NEW
          ? onlineCourseFeedbackData
          : state.onlineCourseFeedbackData[id].concat(onlineCourseFeedbackData);
      const hasMoreFeedback = onlineCourseFeedbackData.length > 0;

      return {
        ...state,
        canReview,
        isLoading: false,
        hasMoreFeedback,
        onlineCourseFeedbackData: { [id]: newData }
      };
    }
    case getType(getOnlineCourseFeedbackActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
